import type { ApolloCache } from '@apollo/client'

/**
 * Evict a deleted PostTemplate from the normalized cache. The Mine list's
 * relay-style connection holds references to the template, so dropping the
 * normalized entry leaves a dangling ref that Apollo filters out on next read.
 */
export function evictMyPostTemplate(cache: ApolloCache, id: string): void {
  cache.evict({ id: cache.identify({ __typename: 'PostTemplate', id }) })
}
